export type LocalOffice = {
  id: string;
  name: string;
  contacts: LocalOfficeContact[]
}

export const CONTACT_LABELS: ContactLabelType[] = ['Finance', 'Orders', 'Sales', 'Transport'];
export type ContactLabelType = 'Finance' | 'Orders' | 'Transport' | 'Sales';

export type LocalOfficeContact = {
  id: string;
  label: ContactLabelType;
  phoneNumber: string;
  email: string;
  enabled?: boolean;
}
